import { Controller } from "stimulus"
import { copyToClipboard, flash } from "../../utils"

export default class extends Controller {
  copy() {
    copyToClipboard(this.data.get("clip"))
    flash("Link copied!")
  }
}
